import * as React from 'react';
import WarningIcon from '@mui/icons-material/Warning';

import { brandColors } from 'brandColors';
import { Message } from './Message';

interface Props {
  singleColumn?: boolean;
}

export const NoCustomer: React.FC<Props> = (props) => {
  const { singleColumn } = props;
  return (
    <Message>
      <WarningIcon style={{ fontSize: '16px', fill: brandColors.colors.orange.DEFAULT }} />
      <h4>
        No reference ID column was recognized in your file.{' '}
        {singleColumn && 'Only one column detected in your file.'}
      </h4>
    </Message>
  );
};
NoCustomer.displayName = 'CustomerAssignment.Message.NoCustomer';
